import { useContext } from 'react';
import { ConfigurationContext } from '../providers/ConfigProvider';
import type { BaseConfigType } from '../types/base';

export function useConfig<T = BaseConfigType>(): T {
  const configContext = useContext(ConfigurationContext);

  if (!configContext) {
    throw new Error('useConfig must be used within a ConfigProvider');
  }

  return configContext.config as T;
}
